__turbopack_context__.v({
  "button": "NavItem-module-scss-module__jkjqSG__button",
  "link": "NavItem-module-scss-module__jkjqSG__link",
  "navItem": "NavItem-module-scss-module__jkjqSG__navItem",
  "navItem_disabled": "NavItem-module-scss-module__jkjqSG__navItem_disabled",
});
